import Joi from "joi";

export const validateSchema = (schema: Joi.ObjectSchema<any>, form: any) => {
  let errors: any = {};
  const isValid = schema.validate(form, {
    allowUnknown: true,
    abortEarly: false,
  });
  if (isValid.error) {
    for (let item of isValid.error.details) {
      errors[item.path[0]] = item.message;
    }

    return { result: false, errors };
  } else return { result: true, errors: null };
};
